module.exports = __webpack_public_path__ + "img/story-2.048bd849.png";